import type React from "react";

import * as styles from "./styles";

import { FullscreenExitRounded, FullscreenRounded } from "@mui/icons-material";

import { ControlButton } from "../ControlButton/ControlButton";

export interface FullscreenControlProps {
  active: boolean;
  className?: string;
  onToggle: (active: boolean) => void;
}

export const FullscreenControl: React.FC<FullscreenControlProps> = ({
  active,
  className,
  onToggle,
}) => {
  const handleToggle = () => onToggle(!active);

  return (
    <div
      className={`leaflet-control ${styles.fullscreenControl} ${
        className || ""
      }`}
    >
      <ControlButton
        Icon={active ? <FullscreenExitRounded /> : <FullscreenRounded />}
        onClick={handleToggle}
      />
    </div>
  );
};
